import { apiService } from "api/apiService";
import type { FilterResource } from "api/generated";
import { myLessonGroupsOverviewFromDto } from "meetings/student-meeting/api/mappers";
import type {
  MeetingMyLessonGroupsOverview,
  MeetingMyLessonGroupsOverviewDto,
} from "meetings/student-meeting/types";

export const fetchMyLessonGroupsMeetings = async (
  teacherId: number,
  params: Record<string, string> = {},
): Promise<MeetingMyLessonGroupsOverview> => {
  const { data } = await apiService.get<MeetingMyLessonGroupsOverviewDto>(
    `api/teacher/${teacherId}/my-lesson-groups/meetings`,
    { params },
  );
  return myLessonGroupsOverviewFromDto(data);
};

export const fetchMyLessonGroupsMeetingsFilters = async (
  teacherId: number,
): Promise<FilterResource[]> => {
  const {
    data: { data: filters },
  } = await apiService.get<{ data: FilterResource[] }>(
    `api/teacher/${teacherId}/my-lesson-groups/meetings/filters`,
  );
  return filters;
};
